export const next =
  typeof requestAnimationFrame === "function"
    ? function next(cb) {
        return requestAnimationFrame(cb);
      }
    : function next(cb) {
        return setTimeout(cb, 16);
      };

export const cancel =
  typeof cancelAnimationFrame === "function"
    ? function cancel(raf) {
        return cancelAnimationFrame(raf);
      }
    : clearTimeout;
